<template>
    <div class="smr-switch">
        <div class="smr-switch__label">
            <icon v-if="icon" class="smr-switch__label__icon"><component :is="icon" /></icon>
            <div class="smr-switch__label__title bold-small-label">{{ label }}</div>
        </div>
        <div class="smr-switch__switch">
            <el-switch v-model="data" @change="changeHandler">
            </el-switch>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue'
import IconBell from '@/components/icons/IconBell.vue'

export default {
    components: {
        Icon,
        IconBell
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: [Boolean, String],
            default: false
        },
        label: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            data: false
        }
    },
    watch: {
        value(val) {
            this.data = val
        }
    },
    mounted() {
        this.setInitialValue()
    },
    methods: {
        changeHandler() {
            this.emitChange()
        },
        setInitialValue() {
            if(this.value) {
                this.data = this.value
            }
        },
        emitChange() {
            this.$emit('change', this.data);
        },
    }
}
</script>

<style lang="scss">
.smr-switch {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__label {
        display: flex;
        align-items: center;
        &__icon {
            color: $color-grey-dark;
            margin-right: 8px;
        }
    }
    .el-switch {
        &.is-checked {
            .el-switch__core {
                background: $color-blue;
                border-color: $color-blue;

                &:after {
                    background: white;
                    margin-left: -20px;
                }
            }
        }
        &__core {
            width: 48px !important;
            height: 28px;
            border-radius: 500px;
            border-color: $color-grey-light;
            background: white;

            &:after {
                width: 14px;
                height: 14px; 
                background: $color-blue;
                top: 6px;
                left: 6px;
            }
        }
    }
}
</style>